export const thankYou = {
  'thankYou.title': 'Thank You!',
  'thankYou.message': 'You have successfully completed registration survey.',
  'thankYou.description':
    'Preferenca is special job board where all candidates come with strong references. You have just completed registration process. What is next? Check and fill in your Company profile so potential candidates can get to know your company. When you finish with Company profile you are ready to search candidates.',
  'thankYou.button': 'Go to Company profile',
}
